module.exports = __webpack_public_path__ + "f08115b7cc2513befd3d07b6fd0a6173.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000009FQ.png
// module id = 1546
// module chunks = 0